import React, { useEffect, useRef, useState } from 'react';

import Pagination from '../../molecules/Pagination';
import ParallaxGrid from '../../molecules/ParallaxGrid';

import MobileFilter from './components/MobileFilter';
import Header from './components/Header';
import Card from './components/Card';

import {
  createCategoryFilters,
  filterBlogPosts,
  filterChecklistPosts,
  filterEvents,
  filterLearningCenterPosts,
  filterPartnershipPosts,
  filterPressPosts,
  sortByDate,
} from './utils/functions';

import useParallaxEffect from '../../hooks/useParallaxEffect';
import usePagination from '../../molecules/Pagination/utils/usePagination';

import { Body, Grid, Section, Wrapper } from './styles/index.styled';

const PostListing = ({
  posts = [],
  type,
  filterState,
  addSort,
  hideSearch,
}) => {
  const contentRef = useRef(null);
  const backgroundRef = useRef(null);
  useParallaxEffect(backgroundRef);

  const [mobileFilterActive, setMobileFilterActive] = useState(false);
  const [activeFilters, setActiveFilters] = useState(filterState);
  const [filteredPosts, setFilteredPosts] = useState(posts);
  const [sortOrder, setSortOrder] = useState('Newest');
  const [resetPage, setResetPage] = useState(false);

  let categoryFilters = createCategoryFilters(posts, type);

  if (addSort) {
    categoryFilters = [
      ...categoryFilters,
      {
        title: 'Sort By',
        categories: ['Newest', 'Oldest'],
      },
    ];
  }

  const {
    activePosts,
    currentPage,
    nextPage,
    pageNumbers,
    paginate,
    prevPage,
  } = usePagination({
    postsPerPage: 21,
    posts: filteredPosts,
    scrollRef: contentRef,
    scrollOffset: 0,
    resetPage,
  });

  useEffect(() => {
    let filtered;

    switch (type) {
      case 'blog':
        filtered = filterBlogPosts(posts, activeFilters);
        break;
      case 'checklists':
        filtered = filterChecklistPosts(posts, activeFilters);
        break;
      case 'events':
        filtered = filterEvents(posts, activeFilters);
        break;
      case 'learning':
        filtered = filterLearningCenterPosts(posts, activeFilters);
        break;
      case 'partnerships':
        filtered = filterPartnershipPosts(posts, activeFilters);
        break;
      case 'product-release':
        filtered = filterBlogPosts(posts, activeFilters);
        break;
      case 'press':
        filtered = filterPressPosts(posts, activeFilters);
        break;
      default:
        break;
    }

    if (addSort) {
      filtered = sortByDate(filtered, sortOrder);
    }

    setFilteredPosts(filtered);
  }, [posts, activeFilters, type, addSort, sortOrder]);

  useEffect(() => {
    setResetPage(true);

    setTimeout(() => {
      setResetPage(false);
    }, 1000);
  }, [activeFilters]);

  return (
    <Section ref={contentRef} className={`post-listing-section-${type}`}>
      <ParallaxGrid theme="light" loading="lazy" />
      <Wrapper>
        <Header
          type={type === 'checklists' ? 'template' : type}
          posts={posts}
          filterState={filterState}
          filters={categoryFilters}
          activeFilters={activeFilters}
          setActiveFilters={setActiveFilters}
          setMobileFilterActive={setMobileFilterActive}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentPosts={activePosts?.length * currentPage}
          totalPosts={filteredPosts?.length || posts.length}
          hideSearch={hideSearch}
        />
        <Body>
          <Grid>
            {activePosts?.map(post => (
              <Card key={post.id} type={type} post={post} />
            ))}
          </Grid>
          <Pagination
            pageNumbers={pageNumbers}
            paginate={paginate}
            currentPage={currentPage}
            nextPage={nextPage}
            prevPage={prevPage}
          />
        </Body>
      </Wrapper>
      <MobileFilter
        filterState={filterState}
        filters={categoryFilters}
        activeFilters={activeFilters}
        setActiveFilters={setActiveFilters}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        mobileFilterActive={mobileFilterActive}
        setMobileFilterActive={setMobileFilterActive}
      />
    </Section>
  );
};

export default PostListing;
